import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';

export const surveysEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-surveys", jiraSpaEntry: "async-servicedesk-surveys" */ './src/ui/SurveysPage'
			),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			context,
		},
	}),
});
